<template>
  <div class="b2b-list-expandable">
    <b2b-list-item @click.stop="$_onClickItem">
      <slot />

      <template #action>
        <component class="b2b-list-expandable__icon" :is="$_icon" />
      </template>
    </b2b-list-item>

    <div ref="container" class="b2b-list-expandable__container">
      <slot name="expand" />
    </div>
  </div>
</template>

<script>
import { ChevronUpIcon, ChevronDownIcon } from 'vue-feather-icons';

import ActivableMixin from '../../../mixins/base/activable-mixin';

import B2bListItem from './b2b-list-item.vue';

export default {
  name: 'b2b-list-expandable',
  mixins: [
    ActivableMixin(),
  ],
  components: {
    B2bListItem,
  },
  computed: {
    $_icon() {
      return this.isActive ? ChevronUpIcon : ChevronDownIcon;
    },
  },
  methods: {
    $_onClickItem() {
      this.isActive = !this.isActive;
    },
    $_setContainerHeight() {
      if (this.isActive) {
        const height = this.$refs.container.scrollHeight;
        this.$refs.container.style.maxHeight = `${height}px`;
      } else {
        this.$refs.container.style.maxHeight = '0px';
      }
    },
  },
  mounted() {
    this.$_setContainerHeight();
  },
  updated() {
    this.$_setContainerHeight();
  },
  watch: {
    isActive() {
      this.$_setContainerHeight();
    },
  },
};
</script>

<style lang="scss">
.b2b-list-expandable {
  &__container {
    padding-left: 48px;

    display: flex;
    overflow: hidden;
    flex-direction: column;

    transition: max-height 0.2s;
  }

  &__icon {
    align-self: center;
  }
}
</style>
